/**
 * Rounds a number to the nearest even number when the fractional part is exactly 0.5,
 * following the "round half to even" (Gaussian rounding) rule.
 * If the fractional part is not 0.5, it rounds normally to the nearest integer.
 *
 * {@link http://stackoverflow.com/a/3109234/42675}
 *
 * @param {number} amount - The number to be rounded.
 * @param {number} [decimalPlaces=0] - The number of decimal places to consider when rounding.
 * @returns {number} - The rounded number, with the specified decimal places if provided.
 *
 * @example
 * // normal rounding
 * roundHalfToEven(1.3); // 1
 * roundHalfToEven(1.5); // 2
 *
 * @example
 * // nearest even tenth
 * roundHalfToEven(1.25, 1); // 1.2
 * roundHalfToEven(1.35, 1); // 1.4
 *
 * @example
 * // nearest even hundredth
 * roundHalfToEven(1.365, 2); // 1.36
 * roundHalfToEven(1.375, 2); // 1.38
 */
export const roundHalfToEven = (amount, decimalPlaces) => {
  const d = decimalPlaces || 0;
  const m = 10 ** d;
  const n = +(d ? amount * m : amount).toFixed(7); // We default to 7 places because that's what our rate fields use on the backend.
  const i = Math.floor(n);
  const f = n - i;
  const e = 1e-7; // Allow for rounding errors in f
  // eslint-disable-next-line no-nested-ternary
  const r = (f > 0.5 - e && f < 0.5 + e) ? ((i % 2 === 0) ? i : i + 1) : Math.round(n);
  
  return d ? r / m : r;
};
